import axiosDefault from "axios";

const axios = axiosDefault.create({
    baseURL: "https://backend.brainspace.sa/api/",
});

export default axios;
